module.exports = __webpack_public_path__ + "static/media/pause.bd9068fe.svg";